<template>
  <div class="py-4 container-fluid">
    <GridRow>
      <GridCol :size="12">
        <MetaSection>
          <ThreeDotsMenu v-if="showData">
            <template v-slot:trigger>
              <ArgonButton
                class="d-flex gap-1 align-items-center"
                type="button"
              >
                Export&nbsp;
                <span>
                  <i
                    class="fas fa-chevron-down cursor-pointer"
                    aria-hidden="true"
                  ></i>
                </span>
              </ArgonButton>
            </template>
            <button
              type="button"
              class="text-secondary font-weight-bold text-xs border-0 bg-transparent"
              @click="convertToCSV"
            >
              Export ke CSV
            </button>
            <button
              type="button"
              class="text-secondary font-weight-bold text-xs border-0 bg-transparent"
              @click="printPage"
            >
              Export ke PDF
            </button>
          </ThreeDotsMenu>
        </MetaSection>
      </GridCol>

      <GridCol :size="12" class="pb-4">
        <div class="d-flex align-items-center justify-content-start gap-2">
          <div class="d-flex justify-content-start w-100 gap-2">

            <FormGroup class="m-0 filter">
              <model-list-select
                class="form-control"
                v-model="params.periode_id"
                :list="
                  list_periode.sort((a, b) => a.name.localeCompare(b.name))
                "
                option-value="id"
                option-text="name"
                placeholder="Pilih Periode"
              />
            </FormGroup>
          </div>
        </div>
      </GridCol>

      <GridCol :size="12">
        <CardComponent :useHeader="true" :withmin="false">

          <div
            class="d-flex justify-content-center text-center border py-10"
            v-if="!showData"
          >
            <h5>Pilih Periode Terlebih Dahulu</h5>
          </div>

          <div v-else id="print-section" ref="printSection">
            <div class="title-print text-center pb-4 visually-hidden">
              <h3>Laporan Kurva Normal Cabang</h3>
              <h2>Periode {{ list_periode?.filter(item => item.id === params.periode_id)?.[0]?.name || '-' }}</h2>
            </div>

            <div class="d-flex flex-column gap-5">
              <div class="d-flex flex-column">
                <div class="mb-2 d-flex items-center justify-content-between">
                  <h5>Kurva Distribusi Normal</h5>
                </div>

                <canvas
                  ref="chartCanvas"
                  style="max-height: 550px"
                  class="border p-4 rounded-2"
                ></canvas>
              </div>

              <div>
                <div class="mb-2 d-flex items-center justify-content-between">
                  <h5>Rekap Yudisium Penilaian</h5>
                </div>

                <div class="chart-wrapper border p-4 rounded-2 w-100">
                  <canvas ref="chartDonut" id="chart-donut-canvas" />
                </div>
              </div>

              <div>
                <div class="mb-2 d-flex items-center justify-content-between">
                  <h5>Daftar Unit Kerja</h5>
                </div>

                <ListView
                  :thead="[
                    'No.',
                    'Unit',
                    'Pimpinan',
                    'Nilai',
                    'Standar Z',
                    'Distribusi Normal',
                  ]"
                  class="table-limit"
                >
                  <template v-slot:tbody>

                    <tr v-if="!chartData?.data || chartData?.data?.length < 1">
                      <td colspan="6" class="text-center text-secondary">
                        Tidak ada data
                      </td>
                    </tr>

                    <tr v-for="(item, index) in chartData?.data" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item?.unitkerja || "-" }}</td>
                      <td>{{ item?.lead_name || "-" }}</td>
                      <td>{{ item?.nilai || item?.nilai === 0 ? item?.nilai : "-" }}</td>
                      <td>{{ item?.z_score || item?.z_score === 0 ? item?.z_score : "-" }}</td>
                      <td>{{ item?.normal_distribution || item?.normal_distribution === 0 ? item?.normal_distribution : "-" }}</td>
                    </tr>
                  </template>
                </ListView>
              </div>
            </div>

            <div class="result">
              <div
                class="result-value d-flex align-items-center justify-content-between border-b border-primary"
              >
                <span>Nilai Rata-rata</span>
                <strong>{{ chartData?.summary?.avg || "-" }}</strong>
              </div>
              <div
                class="result-value d-flex align-items-center justify-content-between border-b border-primary"
              >
                <span>Standar Deviasi</span>
                <strong>{{ chartData?.summary?.stddev || "-" }}</strong>
              </div>
            </div>
          </div>
        </CardComponent>
      </GridCol>
    </GridRow>
  </div>
</template>

<script>
import CardComponent from "@/components/CardComponent.vue";
import KpiPeriodeApi from "@/repository/api/KpiPeriodeApi";
import LaporanKurvaNormalApi from "@/repository/api/LaporanKurvaNormalApi";
import MetaSection from "@/components/MetaSection.vue";
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
import ListView from "@/components/ListView.vue";
import FormGroup from "@/components/FormGroup.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import Chart from "chart.js/auto";
import ThreeDotsMenu from "@/components/ThreeDotsMenu.vue";
import moment from "moment";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export default {
  name: "tables",
  components: {
    CardComponent,
    MetaSection,
    GridRow,
    GridCol,
    ListView,
    FormGroup,
    ArgonButton,
    ModelListSelect,
    ThreeDotsMenu,
  },
  data() {
    return {
      moment,
      list_periode: [],

      unitkerja: [],
      params: {
        periode_id: "",
        page: "all",
      },

      chartInstance: null,
      chartDonutInstance: null,
      chartBarInstance: null,

      showData: false,
      chartData: null,
    };
  },
  watch: {
    params: {
      handler(newValue) {
        if (newValue.periode_id) this.getChartData();
      },
      deep: true,
    },
  },
  methods: {
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    async printPage() {
      const printEl = this.$refs.printSection;
      if (!printEl) return;

      const tableLimit = printEl.querySelector(".table-limit");
      let originalMaxHeight;

      if (tableLimit) {
        originalMaxHeight = tableLimit.style.maxHeight;
        tableLimit.style.maxHeight = "unset";
        tableLimit.style.overflow = "visible";
      }

      await this.$nextTick();

      const pdf = new jsPDF("p", "mm", "a4");
      const margin = 15;
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const usableWidth = pageWidth - margin * 2;
      const usableHeight = pageHeight - margin * 2;

      // HALAMAN 1: CHART (2 chart - Normal & Donut)
      const chartCanvas = this.$refs.chartCanvas;
      const chartDonut = this.$refs.chartDonut;

      const chartNormalCanvas = await html2canvas(chartCanvas.parentElement, {
        scale: 1.5,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
      });

      const chartDonutCanvas = await html2canvas(
        chartDonut.parentElement.parentElement,
        {
          scale: 1.5,
          useCORS: true,
          logging: false,
          backgroundColor: "#ffffff",
        }
      );

      const chartNormalImg = chartNormalCanvas.toDataURL("image/jpeg", 0.85);
      const chartDonutImg = chartDonutCanvas.toDataURL("image/jpeg", 0.85);

      let currentY = margin;

      // title section
      const titleSection = printEl.querySelector(".title-print");
      const clonedTitle = titleSection.cloneNode(true);
      clonedTitle.classList.remove("visually-hidden");

      // Render clonedTitle into canvas
      const titleContainer = document.createElement("div");
      titleContainer.style.background = "#ffffff";
      titleContainer.appendChild(clonedTitle);
      document.body.appendChild(titleContainer);

      const titleCanvas = await html2canvas(titleContainer, {
        scale: 1.5,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
      });

      document.body.removeChild(titleContainer);

      const titleImg = titleCanvas.toDataURL("image/jpeg", 0.85);
      const titleHeight =
        (titleCanvas.height * usableWidth) / titleCanvas.width;

      // Add title before chart
      pdf.addImage(titleImg, "JPEG", margin, currentY, usableWidth, titleHeight);
      currentY += titleHeight + 10;

      // Chart 1: Normal Distribution
      const chartNormalHeight =
        (chartNormalCanvas.height * usableWidth) / chartNormalCanvas.width;
      if (currentY + chartNormalHeight > pageHeight - margin) {
        pdf.addPage();
        currentY = margin;
      }
      pdf.addImage(
        chartNormalImg,
        "JPEG",
        margin,
        currentY,
        usableWidth,
        chartNormalHeight
      );
      currentY += chartNormalHeight + 8;

      // Chart 2: Donut
      const chartDonutHeight =
        (chartDonutCanvas.height * usableWidth) / chartDonutCanvas.width;
      if (currentY + chartDonutHeight > pageHeight - margin) {
        pdf.addPage();
        currentY = margin;
      }
      pdf.addImage(
        chartDonutImg,
        "JPEG",
        margin,
        currentY,
        usableWidth,
        chartDonutHeight
      );

      // HALAMAN 2+: TABLE + RESULT (CHUNKED)
      const tableSection = printEl.querySelector(
        ".d-flex.flex-column.gap-5 > div:nth-child(3)"
      );
      const resultSection = printEl.querySelector(".result");

      const tempContainer = document.createElement("div");
      tempContainer.style.padding = "20px";
      tempContainer.style.backgroundColor = "#ffffff";
      tempContainer.appendChild(tableSection.cloneNode(true));
      tempContainer.appendChild(resultSection.cloneNode(true));
      document.body.appendChild(tempContainer);

      const tableResultCanvas = await html2canvas(tempContainer, {
        scale: 1.5,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
      });

      document.body.removeChild(tempContainer);

      const imgWidth = usableWidth;
      const imgHeight =
        (tableResultCanvas.height * usableWidth) / tableResultCanvas.width;

      pdf.addPage();
      let yOffset = 0;
      let pageY = margin;

      while (yOffset < imgHeight) {
        const remainingHeight = imgHeight - yOffset;
        const heightToDraw = Math.min(remainingHeight, usableHeight);

        const sourceY = (yOffset / imgHeight) * tableResultCanvas.height;
        const sourceHeight =
          (heightToDraw / imgHeight) * tableResultCanvas.height;

        const croppedCanvas = document.createElement("canvas");
        croppedCanvas.width = tableResultCanvas.width;
        croppedCanvas.height = sourceHeight;

        const ctx = croppedCanvas.getContext("2d");
        ctx.drawImage(
          tableResultCanvas,
          0,
          sourceY,
          tableResultCanvas.width,
          sourceHeight,
          0,
          0,
          tableResultCanvas.width,
          sourceHeight
        );

        const croppedImg = croppedCanvas.toDataURL("image/jpeg", 0.85);
        pdf.addImage(croppedImg, "JPEG", margin, pageY, imgWidth, heightToDraw);

        yOffset += heightToDraw;

        if (yOffset < imgHeight) {
          pdf.addPage();
          pageY = margin;
        }
      }

      if (tableLimit) {
        tableLimit.style.maxHeight = originalMaxHeight;
        tableLimit.style.overflow = "auto";
      }

      pdf.save(`laporan_kurva_normal_cabang_${this.moment().unix()}.pdf`);
    },
    convertToCSV() {
      const csvData = this.convertJSONToCSV(
        this.chartData?.data?.map((item) => {
          return {
            unitkerja: item?.unitkerja ?? "",
            lead_name: item?.lead_name ?? "",
            nilai_akhir: item?.nilai_akhir ?? "",
            z_score: item?.z_score ?? "",
            normal_distribution: item?.normal_distribution ?? "",
          };
        })
      );
      this.downloadCSV(
        csvData,
        `laporan_kurva_normal_cabang_${this.moment().unix()}.csv`
      );
    },
    convertJSONToCSV(jsonData) {
      const headers = Object.keys(jsonData[0]);
      const csvRows = [];

      csvRows.push(headers.join(","));

      jsonData.forEach((row) => {
        const values = headers.map((header) => {
          const value = row[header];
          return JSON.stringify(value);
        });
        csvRows.push(values.join(","));
      });

      return csvRows.join("\n");
    },
    downloadCSV(csvData, filename) {
      const blob = new Blob([csvData], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    async getChartData() {
      this.$store.state.loading = true;
      this.chartData = null;
      this.showData = false;

      await LaporanKurvaNormalApi.getKurvaNormalCabang(this.params)
        .then((response) => {
          this.showData = true;

          this.chartData = response?.data || null;
          setTimeout(() => {
            this.createChart();
            this.createChartDonut();
          }, 50);
        })
        .catch(() => {
          this.showData = false;
          this.chartData = null;
        });
      this.$store.state.loading = false;
    },
    async getPeriode() {
      this.$store.state.loading = true;
      await KpiPeriodeApi.getbyparam({ page: "all", status: "active" })
        .then((response) => {
          this.list_periode = response?.data;
        })
        .catch(() => {
          this.list_periode = [];
        });
      this.$store.state.loading = false;
    },

    // Gaussian (Normal Distribution) Function
    gaussian(x, mean = 0, sigma = 0.5) {
      const coeff = 1 / (sigma * Math.sqrt(2 * Math.PI));
      const exponent = -((x - mean) ** 2) / (2 * sigma ** 2);
      return coeff * Math.exp(exponent);
    },

    createChart() {
      const normal_dist_data =
        this.chartData?.chart_data?.normal_distribution || [];

      const rawX = this.chartData?.chart_data?.z_score?.reverse() || [];
      const xValues = rawX.map(v => Number(v));  // IMPORTANT: convert to number
      const yValues = normal_dist_data;

      const ctx = this.$refs.chartCanvas.getContext("2d");

      this.chartInstance = new Chart(ctx, {
        type: "line",
        data: {
          labels: xValues,
          datasets: [
            {
              label: "Normal Distribution",
              data: yValues,
              borderColor: "rgba(54, 162, 235, 1)",
              borderWidth: 2,
              tension: 0.4, // Smooth curve
              pointBackgroundColor: "red",
              pointBorderColor: "red",
              pointRadius: 5,
              fill: false,
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              enabled: true,
              callbacks: {
                label: (context) => `y: ${context.parsed.y.toFixed(3)}`,
              },
            },
          },
          scales: {
            x: {
              title: { display: false },
              ticks: {
                callback: function (val, index) {
                  return xValues[index];
                },
              },
            },
            y: {
              beginAtZero: true,
              title: { display: false },
              position: 'center',
            },
          },
        },
      });
    },
    createChartDonut() {
      const chart_data = [
        this.chartData?.summary?.count_memuaskan || 0,
        this.chartData?.summary?.count_sangat_baik || 0,
        this.chartData?.summary?.count_baik || 0,
        this.chartData?.summary?.count_cukup || 0,
        this.chartData?.summary?.count_kurang || 0,
      ];

      const ctx = this.$refs.chartDonut.getContext("2d");

      this.chartDonutInstance = new Chart(ctx, {
        type: "doughnut",
        data: {
          labels: ["Memuaskan", "Sangat Baik", "Baik", "Cukup", "Kurang"],
          datasets: [
            {
              data: chart_data,
              backgroundColor: [
                "#4CAF50",
                "#0385f3",
                "#C5E0FE",
                "#FF8200",
                "#FF0000",
              ],
              hoverOffset: 4,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false, // allow fixed height
          aspectRatio: 1, // keep chart circular (1:1)
          plugins: {
            legend: {
              position: "bottom",
              labels: {
                usePointStyle: true,
                generateLabels: (chart) => {
                  const { data } = chart;
                  return data.labels.map((label, i) => ({
                    text: `${label} ${data.datasets[0].data[i]}`,
                    fillStyle: data.datasets[0].backgroundColor[i],
                    strokeStyle: data.datasets[0].backgroundColor[i],
                    pointStyle: "circle",
                  }));
                },
              },
            },
            tooltip: {
              callbacks: {
                label: (context) => `${context.label}: ${context.parsed}`,
              },
            },
          },
        },
      });
    },
  },
  async mounted() {
    await this.getPeriode();
  },

  beforeUnmount() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  },
};
</script>

<style>
.chart-wrapper {
  width: 350px; /* fixed width */
  height: 350px; /* fixed height (same as width to keep circle) */
  margin: 0 auto; /* center horizontally */
  display: flex;
  justify-content: center;
  align-items: center;
}

canvas {
  width: 100% !important;
  height: 100% !important;
}

.result {
  margin-top: 16px;
  background: #d9eafe;
  color: #0385f3;
}
.result .result-value {
  padding: 8px 16px;
}
.result .result-value:nth-child(1) {
  border-bottom: 1px solid #c5e0fe !important;
}

.threedotsmenu-hover {
  width: fit-content !important;
  padding-right: 40px !important;
}

.table-limit {
  max-height: 740px;
  overflow-y: auto;
}

/* PRINT ONLY SPECIFIC AREA */
@media print {
  body * {
    visibility: hidden !important;
  }

  #print-section,
  #print-section * {
    visibility: visible !important;
    break-inside: avoid !important;
    page-break-inside: avoid !important;
  }

  #print-section {
    position: absolute !important;
    inset: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
    height: auto !important;
    overflow: visible !important;
    box-sizing: border-box !important;
  }

  #print-section > * {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    break-before: avoid !important;
    break-after: avoid !important;
    break-inside: avoid !important;
  }

  canvas#chart-donut-canvas {
    width: 1450px !important;
    height: 280px !important;
  }

  .table-limit {
    max-height: fit-content;
    overflow-y: auto;
  }

  @page {
    size: A4 landscape;
    margin: 0 !important;
  }
}
</style>
